import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actions", "handleTooltip", "responsiveSize", "onDropdownOpenChange"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memoize } from 'underscore';
// @ts-expect-error not typed yet
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error not typed yet
import { openConfirmEditGlobal } from 'ContentEditorUI/redux/actions/appActions';
import { hashFunctionForObject } from './helpers';
// @ts-expect-error not typed yet
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
import { getIsTrellisTheme } from '../../redux/selectors/layoutSectionDndSelectors';
import { useSelector } from 'react-redux';
import SimpleActionsToolbar from 'layout-dnd-components/DndToolbar/SimpleActionsToolbar';
// @ts-expect-error not typed yet
import { openSwapFooterModal } from 'ContentEditorUI/redux/actions/appActions';
import { jsx as _jsx } from "react/jsx-runtime";
const buildModuleEditAction = ({
  moduleId,
  isEditable,
  bus,
  dispatch,
  moduleType,
  isInNonDefaultBreakpointMode
}) => {
  let tooltipKey = 'inpage.actionToolbar.module.';
  let placements = {
    placement: 'bottom left'
  };
  if (isInNonDefaultBreakpointMode) {
    tooltipKey += 'cantEditMobile';
    placements = {
      placement: 'bottom left'
    };
  } else {
    if (isEditable) {
      tooltipKey += 'edit';
    } else {
      tooltipKey += 'cantEditGlobal';
    }
  }
  return Object.assign({
    id: 'module-edit',
    icon: () => null,
    menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.module.editContent"
    }),
    tooltipLabel: I18n.text(tooltipKey),
    disabled: !isEditable || isInNonDefaultBreakpointMode,
    onlyInDropdown: true
  }, placements, {
    callback: () => {
      dispatch(openConfirmEditGlobal(moduleId));
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.EDIT_MODULE, {
        moduleType
      }));
    }
  });
};
const buildSwapFooterAction = ({
  isEditable,
  bus,
  isInNonDefaultBreakpointMode,
  dispatch
}) => {
  let tooltipKey = 'inpage.actionToolbar.module.';
  let placements = {
    placement: 'bottom left'
  };
  if (isInNonDefaultBreakpointMode) {
    tooltipKey += 'cantEditMobile';
    placements = {
      placement: 'bottom left'
    };
  } else {
    if (isEditable) {
      tooltipKey += 'edit';
    } else {
      tooltipKey += 'cantEditGlobal';
    }
  }
  return Object.assign({
    id: 'swap-footer',
    icon: () => null,
    menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.footer.swapFooter"
    }),
    tooltipLabel: I18n.text(tooltipKey),
    disabled: isInNonDefaultBreakpointMode,
    onlyInDropdown: true
  }, placements, {
    callback: () => {
      dispatch(openSwapFooterModal());
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.SWAP_FOOTER));
    }
  });
};
export const buildFooterActions = memoize(({
  moduleId,
  moduleType,
  isInNonDefaultBreakpointMode,
  dispatch,
  bus,
  isEditable
}) => {
  const editAction = buildModuleEditAction({
    moduleId,
    isEditable,
    bus,
    dispatch,
    moduleType,
    isInNonDefaultBreakpointMode
  });
  const swapFooterAction = buildSwapFooterAction({
    isEditable,
    bus,
    isInNonDefaultBreakpointMode,
    dispatch
  });
  return [editAction, swapFooterAction];
}, hashFunctionForObject);
export const BaseResponsiveFooterToolbar = _ref => {
  let {
      actions,
      handleTooltip,
      responsiveSize,
      onDropdownOpenChange
    } = _ref,
    toolbarProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTrellisTheme = useSelector(getIsTrellisTheme);
  return /*#__PURE__*/_jsx(SimpleActionsToolbar, Object.assign({
    "data-test-id": "hs-footer-actions-toolbar",
    position: "absolute",
    zIndex: 5001,
    active: true,
    isTrellisTheme: isTrellisTheme,
    actions: actions,
    onDropdownOpenChange: onDropdownOpenChange,
    responsiveSize: responsiveSize,
    handleTooltip: handleTooltip || '',
    handleTooltipPlacement: "left",
    dropdownPlacement: "bottom left",
    label: I18n.text('inpage.actionToolbar.footer.dropdownLabel')
  }, toolbarProps));
};
BaseResponsiveFooterToolbar.propTypes = {
  actions: PropTypes.array.isRequired,
  responsiveSize: PropTypes.string.isRequired,
  handleTooltip: PropTypes.string,
  onDropdownOpenChange: PropTypes.func,
  moduleId: PropTypes.string
};